<div class="modal-wrapper sm" (click)="close()" [class.show]="modalVisible">
  <div class="modal" (click)="$event.stopPropagation();">
    <div class="modal-header">
      <span class="modal-title">You have been idle!</span>
      <span class="close" (click)="close()">
        <svg class="icon fill-current sm">
          <use xlink:href="#cross"></use>
        </svg>
      </span>
    </div>
    <div class="modal-body">
      <p class="m-0">Your session will expire in {{instance?.countDown - instance?.count}} seconds.</p>
    </div>
    <div class="modal-footer text-right">
      <button class="btn btn-secondary" (click)="instance?.logout()">Logout</button>
      <button class="btn btn-primary" (click)="close()">Continue</button>
    </div>
  </div>
</div>

